import { Loader } from 'rsuite';
import Logo from '../../assets/images/brand/new_logo_foreground.webp';
export const SplashPage = (props: { connected: boolean }) => {
  return (
    <div className="h-[100%] w-[100%] bg-[--rs-primary-500] text-[--rs-white] fixed top-0 left-0 flex items-center flex-col">
      <div className="mt-[25vh]">
        <img className="w-[250px] max-w-[100%]" src={Logo} alt="" />
      </div>
      <div className="italic font-bold text-[30px]">MedMe</div>
      {props.connected ? (
        <div className="mt-[16vh]">
          <Loader size="md" className="splash-loader" />
        </div>
      ) : null}
      {!props.connected ? (
        <div className="mt-[16vh]">اتصال به اینترنت را چک کنید</div>
      ) : (
        <div>لطفا صبر کنید ...</div>
      )}
    </div>
  );
};
